import styled from 'styled-components'

import { Widget as WidgetBase } from '@icontainers/widget'

export const WidgetWrapper = styled.div``

export const Widget = styled(WidgetBase)`
    padding-top: 5px;
    padding-bottom: 5px;

    & > div {
        max-width: none;
    }

    form {
        justify-content: start;
    }

    //TODO: need to fix issue by widget
    input[name='cargoReadyDate'] {
        &::-webkit-input-placeholder {
            opacity: 0 !important;
        }
        &::-ms-input-placeholder {
            opacity: 0 !important;
        }
        &::placeholder {
            opacity: 0 !important;
        }
    }
`

export const StickyWidgetWrapper = styled.div`
    transition: background 0.3s;

    &.sticky {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        background-color: ${(props) => props.theme.color.p600};
        z-index: 10;

        ${Widget} {
            max-width: 1170px;
            margin: 0 auto;
            padding-left: 45px;
            padding-right: 45px;
        }
    }
`

export const GhostWidgetElement = styled.div<{ $height: number }>`
    height: ${(props) => props.$height}px;
`
